export default "__VITE_ASSET__sFRkQHjC__"